import { useNavigate, useSearchParams } from "react-router-dom";
import PageTitle from "../Helpers/PageTitle";
import Layout from "../Partials/Layout";
import { useEffect, useState } from "react";
import axios from "../../api/axios";
import { toast } from "react-toastify";

export default function CheckoutFail() {
  window.scrollTo(0, 0);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const trnId = searchParams.get("trnId");
  const status = searchParams.get("status");
  const errorMessage =
    searchParams.get("error") || "Your Order has Failed. Please try again.";
  const [loading, setLoading] = useState(!!orderId);

  useEffect(() => {
    if (orderId) {
      const fetchOrderStatus = async () => {
        try {
          let response;
          // Check if this is a PayHere order
          if (orderId.startsWith("ph-")) {
            const actualOrderId = orderId.replace("ph-", "");
            response = await axios.get(`/orders/payhere/${actualOrderId}`);
          }
          // Check if this is a Koko order
          else if (trnId && status) {
            response = await axios.get(`/orders/koko/${orderId}`);
          } else {
            response = await axios.get(`/orders/${orderId}`);
          }

          if (response.data && response.data.length > 0) {
            const orderData = response.data[0];
            const fetchedOrderId = orderData.id;
            // Check if the order status indicates success
            if (
              orderData.status === "completed" ||
              orderData.status === "processing" ||
              orderData.status === "pending" ||
              orderData.status === "paid"
            ) {
              navigate(`/checkout-success?orderId=${fetchedOrderId}`);
              return;
            }
          }
        } catch (error) {
          console.error("Error checking order status:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchOrderStatus();
    } else {
      setLoading(false);
    }
  }, [orderId, trnId, status, navigate]);

  if (loading) {
    return (
      <Layout childrenClasses="pt-0 pb-0">
        <div
          className="checkout-page-wrapper w-full bg-white pb-[60px] flex justify-center items-center"
          style={{ minHeight: "300px" }}
        >
          <p>Checking order status...</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout childrenClasses="pt-0 pb-0">
      <div className="checkout-page-wrapper w-full bg-white pb-[60px]">
        <div className="w-full mb-5">
          <PageTitle
            title={errorMessage}
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "checkout-fail", path: "/checkout-fail" },
            ]}
          />
        </div>
        <div className="checkout-main-content w-full">
          <div className="container-x mx-auto">
            <div className="w-full lg:flex lg:space-x-[30px]">
              <div className="flex-1">
                <h1 className="sm:text-2xl text-xl text-qblack font-medium mb-5">
                  Order Failed {orderId ? `#${orderId}` : ""}
                </h1>

                <div className="w-full px-10 py-[30px] border border-[#EDEDED]">
                  <p className="text-[15px] text-qgray mb-5">
                    We're sorry, but there was an issue processing your order.
                    Please try again or contact customer support if the problem
                    persists.
                  </p>

                  <button onClick={() => navigate("/all-products")}>
                    <div className="w-full h-[50px] black-btn flex justify-center items-center">
                      <span className="text-sm font-semibold">
                        Continue Shopping
                      </span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
